import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import { boxSpacer } from '../space';
import { borderRadius } from '../utils';
export var code = function code(props) {
  return {
    backgroundColor: props.theme.colors[props.theme.code.bg],
    color: props.theme.colors[props.theme.code.color],
    lineHeight: props.theme.code.lineHeight,
    fontWeight: props.theme.code.fontWeight,
    letterSpacing: props.theme.code.letterSpacing,
    fontFamily: props.theme.code.fontFamily,
    overflow: 'auto',
    speak: 'literal-punctuation'
  };
};
export var pre = function pre(props) {
  return _objectSpread(_objectSpread({
    border: "1px solid ".concat(props.theme.colors[props.theme.code.borderColor])
  }, borderRadius({
    theme: props.theme,
    borderRadius: props.theme.radius
  })), {}, {
    padding: "".concat(props.theme.code.blockPaddingY, " ").concat(props.theme.code.blockPaddingX),
    fontSize: props.theme.code.blockFontSize
  });
};
var Pre = styled('pre').withConfig({
  displayName: "Pre",
  componentId: "sc-6iev2o-0"
})(code, pre, boxSpacer);
Pre.code = code;
Pre.pre = pre;
export default Pre;